var a = (o, r, i) => new Promise((d, s) => {
  var p = (t) => {
    try {
      e(i.next(t));
    } catch (n) {
      s(n);
    }
  }, c = (t) => {
    try {
      e(i.throw(t));
    } catch (n) {
      s(n);
    }
  }, e = (t) => t.done ? d(t.value) : Promise.resolve(t.value).then(p, c);
  e((i = i.apply(o, r)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function A(o) {
  return a(this, null, function* () {
    const {
      data: r
    } = yield f.post(
      "/designordercenter/productionOrder/aiOperation/getAiModifyList",
      o
    );
    return r;
  });
}
export {
  A as postGetAiModifyList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/operation/getAiModifyList/post.js
// module id = 1815
// module chunks = 67